import React, { useState, useEffect } from 'react';
import { Button, Table, Spin } from 'antd';
import { incidentService } from '@iso/services';
import IntlMessages from '@iso/components/utility/intlMessages';
import AddActivityModal from './AddActivityModal';
import moment from 'moment';
import IncidentModalWrapper from './IncidentModal.styles';

const ActivityListModal = ({ visible, onCancel, incident }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const response = await incidentService.getActivities({
        incident_id: incident.id,
        expand: 'attachments',
      });
      setActivities(response.items);
    } catch (error) {
      console.error('There was an error fetching the activities!', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (incident?.id) {
      fetchActivities();
    }
  }, [incident]);

  const columns = [
    {
      title: <IntlMessages id="incidentPage.activity.table.title" />,
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: <IntlMessages id="incidentPage.activity.table.description" />,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: <IntlMessages id="incidentPage.activity.table.createdDate" />,
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => moment(text).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: '',
      key: 'actions',
      render: (text, record) => (
        <Button type="link" onClick={handleView(record)}>
          <IntlMessages id="incidentPage.activity.table.view" />
        </Button>
      ),
    }
  ];

  const handleAddActivity = () => {
    setAddModalVisible(true);
    setSelectedActivity(null);
  };

  const handleAddModalClose = () => {
    setAddModalVisible(false);
  };

  const handleActivitySaved = () => {
    setAddModalVisible(false);
    fetchActivities();
  };

  const handleView = (activity) => () => {
    console.log("handleView -> activity", activity);
    setSelectedActivity(activity);
    setAddModalVisible(true);
  };

  return (
    <IncidentModalWrapper
      visible={visible}
      onCancel={onCancel}
      title={<IntlMessages id="incidentPage.activity.modal.title" />}
      footer={[]}
      width={800}
    >
      <div className="form-body">
        <div className='button-group' style={{ textAlign: 'right', marginBottom: 16 }}>
          <Button
            type="primary"
            className="btn-success"
            onClick={handleAddActivity}
          >
            <IntlMessages id="incidentPage.activity.modal.addActivity" />
          </Button>
        </div>

        <Spin spinning={loading}>
          <Table columns={columns} dataSource={activities} rowKey="id" pagination={false} />
        </Spin>

        <AddActivityModal
          visible={addModalVisible}
          onCancel={handleAddModalClose}
          onSaved={handleActivitySaved}
          incident={incident}
          activity={selectedActivity}
        />
      </div>
    </IncidentModalWrapper>
  );
};

export default ActivityListModal;